// StatisticaPersonal.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { personalStatisticsActions } from './actions';
import PersonalFilters from './components/PersonalFilters';
import PersonalMainTable from './components/PersonalMainTable';
import PersonalDetailTable from './components/PersonalDetailTable';
import './StatisticaPersonal.css';

const StatisticaPersonal = () => {
  const [selDist, setSelDist] = useState('all');
  const [showDetailKg, setShowDetailKg] = useState(false);
  const [detInfo, setDetInfo] = useState({});
  const [infoInvites, setInfoInvites] = useState([]);
  const [loading, setLoading] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);

  const unsetDetailInfoKg = useCallback(() => {
    setDetInfo({});
    setShowDetailKg(false);
  }, []);

  const getInfoAboutInvites = useCallback(async () => {
    setLoading(true);
    setShowDetailKg(false);
    try {
      const res = await personalStatisticsActions.getStatisticsPersonal(selDist);
      
      if (res.data) {
        setInfoInvites(res.data);
      } else {
        setInfoInvites([]);
      }
    } catch (error) {
      console.error('Error fetching statistics:', error);
      setInfoInvites([]);
    } finally {
      setLoading(false);
    }
  }, [selDist]);

  const setDetailInfoKg = useCallback(async (kgId, kgNumber) => {
    setDetailLoading(true);
    try {
      const res = await personalStatisticsActions.getPersonalStatisticsByKg(kgId);
      
      if (res.data) {
        setDetInfo({ data: res.data, kg_number: kgNumber });
        setShowDetailKg(true);
      }
    } catch (error) {
      console.error('Error fetching personal statistics:', error);
    } finally {
      setDetailLoading(false);
    }
  }, []);

  useEffect(()=>{
    getInfoAboutInvites();
  },[selDist])

  const handleDistrictChange = useCallback((e) => {
    setShowDetailKg(false);
    setInfoInvites([]);
    setSelDist(e.target.value);
  }, []);

  return (
    <div className="personal-container">
      <PersonalFilters
        selDist={selDist}
        loading={loading}
        onDistrictChange={handleDistrictChange}
        onShowData={getInfoAboutInvites}
      />

      {!showDetailKg && (
        <PersonalMainTable
          data={infoInvites}
          onRowClick={setDetailInfoKg}
          loading={loading}
        />
      )}
      
      {showDetailKg && (
        <PersonalDetailTable
          data={detInfo.data}
          kgNumber={detInfo.kg_number}
          onBack={unsetDetailInfoKg}
          loading={detailLoading}
        />
      )}
    </div>
  );
};

export default StatisticaPersonal;